import { api } from './../../api.js';
import { config } from './../../config.js';

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
    BACK_RECORDATORIOS_INDEX: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.recordatorios.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_RECORDATORIOS_DELETE: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.recordatorios.borrar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
}

export default {
    state,
    actions,
    getters,
    mutations
};